export default "__VITE_ASSET__QFoNqLuA__"